import { gql } from "@apollo/client";

const PublicareClientFragment = gql`
  fragment PublicareClientFragment on PublicareClient {
    _id
    telephoneNumber
    type
    isInstitution
    emailAddress
    customerNumber
    contactNumber
    companyNumber
    gender
    name
    additionalName
    firstName
    lastName
    birthday
    addressLine
    addressLine2
    postalCode
    city
    countryCode
    languageCode
    insuranceName
    regionCode
    mobileNumber
    isNotifyByEmailEnabled
    isNewCustomer
    isNotifyPatientByEmailEnabled
    emailNotificationAddress
    patientEmailNotificationAddress
    isNotifyByMobileEnabled
    insuranceHeadquarters
    insuranceNumber
    invalidityNumber
    familyDoctor
    isValidated
    roles
    isPrivateCustomer
    emsDepartmentDescription
    showEMSDepartment
    prescriber {
      contactNumber
      contactName
      contactEmail
    }
    doctors {
      contactNumber
      contactName
      contactEmail
    }
    institution {
      _id
    }
    cart {
      _id
      items {
        _id
        quantity
      }
    }
  }
`;

export default PublicareClientFragment;
